// src/api/userApi.js
import { TUserInfo } from '@utils/Interfaces';
import apiClient from './apiConfig';

const userApi = {
    updateUserProfile: (data: TUserInfo) => {
        return apiClient.post('/user/', data)
    },
    updateUserSkills: (data: TUserInfo) => {
        return apiClient.post('/skills/delete/insert/', data)
    },
    updateUserExperience: (data: TUserInfo) => {
        return apiClient.post('/experience/delete/insert/', data)
    },
    getUserExperience: () => {
        return apiClient.get('/experience/')
    },
    updateUserLanguages: (data: TUserInfo) => {
        return apiClient.post('/languages/delete/insert/', data)
    },
    updateUserEducation: (data: TUserInfo) => {
        return apiClient.post('/education/', data)
    }
};

export default userApi;
